
import { FolderListItem } from '../../viewModels/Folder';
export const sortFolders = (source: Array<FolderListItem>, getSortFn: any) => {
    const sortedResult: Array<FolderListItem> = [];

    const sortFn = getSortFn('name', 'ASC');

    const recurse = (parentFolderId: string | undefined) => {
        const folders = source.filter(f => f.parentFolderId === parentFolderId);
        folders.sort(sortFn);
        folders.forEach(folder => {
            sortedResult.push(folder);
            recurse(folder.id);
        });
    };

    recurse(undefined);

    return sortedResult;
};
